module.exports = __webpack_public_path__ + "media/images/river/shirts-row-7118b97577d3291b54e52e60b4c90ff2.jpg";